import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import { Splash } from './components/Loader';
import { useFund } from './context/FundContext';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Accounting from './pages/Accounting';
import NavPack from './pages/NavPack';
import Portfolio from './pages/Portfolio';
import Investor from './pages/Investor';
import Performance from './pages/Performance';
import GainLoss from './pages/GainLoss';

export default function App() {
  const { isAuthed } = useAuth();
  const { loading, error } = useFund();

  // Mobile off-canvas nav. Open state lives here so the topbar's hamburger and
  // the sidebar/backdrop can all drive it; it auto-closes on route change.
  const [navOpen, setNavOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setNavOpen(false); }, [pathname]);

  // Not signed in — show the login screen before touching any fund data.
  if (!isAuthed) return <Login />;

  if (loading) return <Splash />;
  if (error) {
    return (
      <div className="splash">
        <img src="/logo.png" alt="Blue Aster Capital" className="splash-logo" />
        <div className="error" style={{ maxWidth: 420 }}>
          Could not reach the MIS API: {error}
          <br />
          Make sure the backend is running on <code>http://localhost:4005</code>.
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Sidebar open={navOpen} onNavigate={() => setNavOpen(false)} />
      {navOpen && <div className="nav-backdrop" onClick={() => setNavOpen(false)} />}
      <div className="main">
        <Header onMenu={() => setNavOpen((v) => !v)} />
        <div className="content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/accounting" element={<Accounting />} />
            <Route path="/nav-pack" element={<NavPack />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/investor" element={<Investor />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/gain-loss" element={<GainLoss />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
